import React, {useEffect, useState} from 'react';
import Link from 'next/link';
import {useRouter} from 'next/router';
import {getLocaleContent} from '@helper/locale-content.js';
import LinkMedicalFacilityDetail from '@components/common/Link/LinkMedicalFacilityDetail';
import MedicalFacility from '@services/medical-facility.service';
import GoogleMapView from '@components/common/GoogleMap/GoogleMapPopup';

export default function ListMedicalFacility() {
    const {locale} = useRouter();
    const [selectedMapUrl, setSelectedMapUrl] = useState(null);
    const [open, setOpen] = useState(false);
    const [hospitals, setHospitals] = useState([]);

    const loadListMedicalFacility = async () => {
        const medicalFacilityService = new MedicalFacility();
        try {
            const data = await medicalFacilityService.getMedicalFacilityHome({locale: locale});
            if (data) {
                // setHospitals(data);
                console.log(data);
                const fixedBusinesses = data.map(b => {
                    let mapUrl = b.mapUrl; // giữ lại nếu đã có

                    if (b.business_name?.includes('Thái Nguyên') || b.business_name?.includes('Thai Nguyen')) {
                        mapUrl =
                            'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7419.92591351833!2d105.82976!3d21.587369!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xc059ef64cbc6b293!2zQuG7h25oIFZp4buHbiBRdcO0zIFjIFTDqsyBIFRoYcyBaSBOZ3V5w6pu!5e0!3m2!1svi!2sus!4v1635393862311!5m2!1svi!2sus';
                    } else if (b.business_name?.includes('Phổ Yên') || b.business_name?.includes('Pho Yen')) {
                        mapUrl =
                            'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d29716.751769817314!2d105.86719314840859!3d21.405886272490253!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31351fe9a02a465d%3A0x861cba2d357f12c6!2zQuG7h25oIFZp4buHbiDEkGEgS2hvYSBZw6puIELDrG5oIFRow6FpIE5ndXnDqm4!5e0!3m2!1svi!2s!4v1686104129648!5m2!1svi!2s';
                    } else if (b.business_name?.includes('Việt Yên') || b.business_name?.includes('Viet Yen')) {
                        mapUrl =
                            'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3718.113232067809!2d106.10101907424647!3d21.26698497955583!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x313513ef19bf8947%3A0x3a66fac7f166c8a!2zQuG7h25oIHZp4buHbiBUTkggVmnhu4d0IFnDqm4!5e0!3m2!1svi!2s!4v1734595877069!5m2!1svi!2s';
                    } else if (b.business_name?.includes('Lạng Sơn') || b.business_name?.includes('Lang Son')) {
                        mapUrl =
                            'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2919.859095899616!2d106.74893180722017!3d21.847053483705068!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x36b54f0021135177%3A0x25c2c442cd3a15b0!2zQuG7h25oIHZp4buHbiBUTkggTOG6oW5nIFPGoW4!5e0!3m2!1svi!2s!4v1780049383996!5m2!1svi!2s';
                    }
                    return {
                        ...b,
                        mapUrl,
                    };
                });

                setHospitals(fixedBusinesses);
            }
        } catch (error) {
            console.error('Error fetching medical facilities:', error);
        }
    };
    useEffect(() => {
        loadListMedicalFacility();
    }, []);

    const handleOpenMap = mapUrl => {
        if (!mapUrl) return;
        setSelectedMapUrl(mapUrl);
        setOpen(true);
    };

    return (
        <section className="hospitals">
            <h2 className="hospitals__title">{getLocaleContent(locale, 'page.medical-facility.title')}</h2>
            <div className="hospitals__grid">
                {hospitals.map((h, idx) => (
                    <div key={idx} className="hospital-card">
                        <img
                            src={h.business_image || '/bw_image/hospital.png'}
                            alt={h.business_name}
                            className="hospital-card__img"
                        />
                        <div className="hospital-card__body">
                            <span className="hospital-card__name">{h.business_name}</span>
                            <div className="hospital-card__address" onClick={() => handleOpenMap(h.mapUrl)}>
                                <img className="hospital-card-img" src="/bw_image/ic_location.svg" alt={h.address} />
                                <p style={{fontSize: '16px'}}>{h.address}</p>
                            </div>
                            {h.business_phone_number && (
                                <div className="hospital-card__phone">
                                    <a href={`tel:${h.business_phone_number}`} className="phone-link">
                                        <img
                                            className="hospital-card-img"
                                            src="/bw_image/ic_call.svg"
                                            alt={h.business_phone_number}
                                        />
                                        <span>{h.business_phone_number}</span>
                                    </a>
                                </div>
                            )}
                            <div className="hospital-card__actions">
                                <Link href="/dat-lich-kham">
                                    <button className="btn btn--outline">
                                        <img
                                            className="hospital-card-img"
                                            src="/bw_image/ic_calendar_f.svg"
                                            alt="calendar"
                                        />
                                        <span>{getLocaleContent(locale, 'common.booking')}</span>
                                    </button>
                                </Link>
                                <LinkMedicalFacilityDetail medicalFacility={h}>
                                    <div className="hospital-card-body__link">
                                        <a href="#" className="hospital-card__link">
                                            {getLocaleContent(locale, 'page.specialty-page.view-detail')}
                                        </a>
                                        <img
                                            className="hospital-card-img"
                                            src="/bw_image/arrow-long-right.svg"
                                            alt="arrow"
                                        />
                                    </div>
                                </LinkMedicalFacilityDetail>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            {/* Google Map */}
            <GoogleMapView mapUrl={selectedMapUrl} open={open} onClose={() => setOpen(false)} />
        </section>
    );
}
